var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_289_350)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1698 35.7501C18.7898 35.7501 16.8398 34.0201 16.8398 31.8901V29.8501C16.8398 29.4401 17.1798 29.1001 17.5898 29.1001C17.9998 29.1001 18.3398 29.4401 18.3398 29.8501C18.3398 31.1001 19.5498 32.0401 21.1698 32.0401C22.7898 32.0401 23.9998 31.1001 23.9998 29.8501C23.9998 29.4401 24.3398 29.1001 24.7498 29.1001C25.1598 29.1001 25.4998 29.4401 25.4998 29.8501V31.8901C25.4998 34.0201 23.5598 35.7501 21.1698 35.7501ZM18.5998 32.8701C19.0398 33.6901 20.0298 34.2501 21.1698 34.2501C22.3098 34.2501 23.2998 33.6801 23.7398 32.8701C23.0298 33.3001 22.1498 33.5501 21.1698 33.5501C20.1898 33.5501 19.3098 33.3001 18.5998 32.8701Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1698 30.7999C19.5298 30.7999 18.0598 30.0499 17.3298 28.8599C17.0098 28.3399 16.8398 27.7299 16.8398 27.1099C16.8398 26.0599 17.2998 25.0799 18.1398 24.3499C19.7598 22.9299 22.5498 22.93 24.1798 24.34C25.0198 25.08 25.4898 26.0599 25.4898 27.1099C25.4898 27.7299 25.3198 28.3399 24.9998 28.8599C24.2798 30.0499 22.8098 30.7999 21.1698 30.7999ZM21.1698 24.7499C20.3898 24.7499 19.6698 25.0099 19.1298 25.4799C18.6198 25.9199 18.3398 26.4999 18.3398 27.1099C18.3398 27.4599 18.4298 27.78 18.6098 28.08C19.0698 28.84 20.0498 29.3099 21.1698 29.3099C22.2898 29.3099 23.2698 28.84 23.7198 28.09C23.8998 27.8 23.9898 27.4699 23.9898 27.1199C23.9898 26.5099 23.7098 25.9299 23.1998 25.4799C22.6698 25.0099 21.9498 24.7499 21.1698 24.7499Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1698 33.55C18.6998 33.55 16.8398 31.96 16.8398 29.86V27.11C16.8398 24.98 18.7798 23.25 21.1698 23.25C22.2998 23.25 23.3798 23.64 24.1898 24.34C25.0298 25.08 25.4998 26.06 25.4998 27.11V29.86C25.4998 31.96 23.6398 33.55 21.1698 33.55ZM21.1698 24.75C19.6098 24.75 18.3398 25.81 18.3398 27.11V29.86C18.3398 31.11 19.5498 32.05 21.1698 32.05C22.7898 32.05 23.9998 31.11 23.9998 29.86V27.11C23.9998 26.5 23.7198 25.92 23.2098 25.47C22.6698 25.01 21.9498 24.75 21.1698 24.75Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0399 27.7999C31.5299 27.7999 30.2499 26.6799 30.1299 25.2399C30.0499 24.4099 30.3499 23.5999 30.9499 23.0099C31.4499 22.4899 32.1599 22.2 32.9099 22.2H34.9999C35.9899 22.23 36.7499 23.0099 36.7499 23.9699V26.03C36.7499 26.99 35.9899 27.7699 35.0299 27.7999H33.0399ZM34.9699 23.7H32.9199C32.5699 23.7 32.2499 23.8299 32.0199 24.0699C31.7299 24.3499 31.5899 24.7299 31.6299 25.1099C31.6799 25.7699 32.3199 26.2999 33.0399 26.2999H34.9999C35.1299 26.2999 35.2499 26.18 35.2499 26.03V23.9699C35.2499 23.8199 35.1299 23.71 34.9699 23.7Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 34.25H27.5002C27.0902 34.25 26.7502 33.91 26.7502 33.5C26.7502 33.09 27.0902 32.75 27.5002 32.75H30.0002C32.5802 32.75 34.2502 31.08 34.2502 28.5V27.8H33.0402C31.5302 27.8 30.2502 26.68 30.1302 25.24C30.0502 24.41 30.3503 23.6 30.9503 23.01C31.4503 22.49 32.1602 22.2 32.9102 22.2H34.2402V21.5C34.2402 19.16 32.8703 17.55 30.6503 17.29C30.4103 17.25 30.2002 17.25 29.9902 17.25H20.9902C20.7502 17.25 20.5202 17.27 20.2902 17.3C18.0902 17.58 16.7402 19.18 16.7402 21.5V23.5C16.7402 23.91 16.4002 24.25 15.9902 24.25C15.5802 24.25 15.2402 23.91 15.2402 23.5V21.5C15.2402 18.42 17.1403 16.19 20.0903 15.82C20.3603 15.78 20.6702 15.75 20.9902 15.75H29.9902C30.2302 15.75 30.5402 15.76 30.8602 15.81C33.8102 16.15 35.7402 18.39 35.7402 21.5V22.95C35.7402 23.36 35.4002 23.7 34.9902 23.7H32.9102C32.5602 23.7 32.2403 23.83 32.0103 24.07C31.7203 24.35 31.5802 24.73 31.6202 25.11C31.6702 25.77 32.3103 26.3 33.0303 26.3H35.0002C35.4102 26.3 35.7502 26.64 35.7502 27.05V28.5C35.7502 31.94 33.4402 34.25 30.0002 34.25Z",
    fill: "#101828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_289_350",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_289_350"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_289_350",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCost);
export default __webpack_public_path__ + "static/media/cost.65ffcbdba26974cf6cd47692d59d40f5.svg";
export { ForwardRef as ReactComponent };